import React, { useContext, useEffect, useState, useRef } from 'react'
import { Input, Button, Typography, message } from 'antd';
import { FaPaperPlane } from 'react-icons/fa';
import StreamWebService from '../classes/StreamWebService';
import { EVT_LIVECHAT_INCOMING, EVT_MSG_NEW, EVT_MSG_SEND } from '../constants';
import GlobalStateContext from '../context';
import './StreamChat.css';

const { Text } = Typography;

export default function StreamChat({ stream }) {
  const [state] = useContext(GlobalStateContext);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const sendMessage = () => {
    console.log("Sending message:", newMessage);
    if (!newMessage.trim()) return;
    console.log("Emitting message event");
    const payload = {
      from: state.user._id,
      sender_name: state.user.name,
      content: newMessage.trim(),
      stream: stream.id,
      source: "app",
      type: 'chat',
      time: new Date().toISOString(),
    };
    console.log("Payload:", payload);
    state.io.emit(EVT_MSG_SEND, payload);
    setMessages([...messages, payload])
    setNewMessage('');
  };

  const onNewLiveMessage = (data) => {
    const messageData = {
      id: data.id || Date.now(),
      from: data.from,
      sender_name: data.sender_name,
      content: data.content,
      createdAt: data.time || new Date().toISOString(),
      isOwn: data.from === state.user._id
    };

    setMessages(prev => [...prev, messageData]);
  };

  const getChats = async () => {
    try {
      setLoading(true);
      const wbs = new StreamWebService();
      const response = await wbs.getChat(stream.id);

      const chatMessages = response.data.map(chat => ({
        id: chat.id || Date.now(),
        from: {
          _id: chat.from,
          name: chat.sender_name || chat.from?.name,
          picture: chat.image || chat.from?.picture
        },
        content: chat.content,
        createdAt: chat.time || chat.createdAt,
        isOwn: chat.from === state.user._id
      }));

      setMessages(chatMessages);
    } catch (error) {
      console.error('Failed to load chat history:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (stream?.id && state.io) {
      const chatEvent = `${EVT_LIVECHAT_INCOMING}_${stream.id}`;
      state.io.on(chatEvent, onNewLiveMessage);
      getChats();

      return () => {
        state.io.removeAllListeners(chatEvent);
      };
    }
  }, [stream?.id, state.io]);

  return (
    <div className="stream-chat-container">
      {/* Chat Header */}


      {/* Messages Area */}
      <div className="chat-messages-area">
        {loading ? (
          <div className="chat-loading">
            <Text type="secondary">Loading chat...</Text>
          </div>
        ) : messages.length === 0 ? (
          <div className="chat-empty">
            <Text type="secondary">Welcome to the chat! 👋</Text>
          </div>
        ) : (
          <div className="messages-list">
            {messages.map((msg) => (
              <div key={msg.id} className={`chat-message ${msg.isOwn ? 'own-message' : ''}`}>
                <div className="message-content">
                  <div className="message-header">
                    <span className="sender-name">{msg.sender_name}</span>
                    <span className="message-time">
                      {new Date(msg.createdAt || msg.time).toLocaleTimeString([], {
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </span>
                  </div>
                  <div className="message-text">
                    {msg.content}
                  </div>
                </div>
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>
        )}
      </div>

      {/* Input Area */}
      <div className="chat-input-area">
        <div className="input-container">
          <Input
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            placeholder="Type a message..."
            onPressEnter={(e) => {
              console.log(newMessage)
              e.preventDefault();
              sendMessage();
            }}
            suffix={
              <Button
                type="text"
                icon={<FaPaperPlane />}
                onClick={sendMessage}
                disabled={!newMessage.trim()}
                className="send-button"
              />
            }
          />
        </div>
      </div>
    </div>
  );
}
